"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isBeforeDate(date) {
    return new Date() < new Date(date);
}
exports.default = isBeforeDate;
